import React from "react";
import { Pressable, StyleSheet, Text, TextInput, View } from "react-native";
import { useLanguage } from "../i18n/LanguageContext.js";
import {
  colorForTriggerKey,
  getDisplayTriggers,
  normalizeTriggerLabel,
  triggerKey,
} from "../storage/triggerLibraryStorage.js";

/**
 * @param {{
 *   triggers: import('../storage/triggerLibraryStorage.js').SavedTrigger[],
 *   value: string,
 *   onChange: (label: string) => void,
 * }} props
 */
export function FailTriggerPicker({ triggers, value, onChange }) {
  const { t } = useLanguage();
  const display = getDisplayTriggers(triggers);
  const selectedKey = triggerKey(value);

  return (
    <View style={styles.wrap}>
      <Text style={styles.sectionTitle}>{t("trigger_title")}</Text>
      <Text style={styles.sectionHint}>{t("trigger_hint")}</Text>

      <View style={styles.cardGrid}>
        {display.map((t) => {
          const key = triggerKey(t.label);
          const selected = selectedKey === key && normalizeTriggerLabel(value).length > 0;
          const color = colorForTriggerKey(key);

          return (
            <Pressable
              key={key}
              style={[styles.triggerCard, selected ? styles.triggerCardOn : null, { borderColor: color }]}
              onPress={() => onChange(t.label)}
            >
              <Text style={[styles.triggerLabel, { color }]}>{t.label}</Text>
              {t.count > 0 ? <Text style={styles.triggerCount}>{t.count}×</Text> : null}
            </Pressable>
          );
        })}
      </View>

      <Text style={styles.customLabel}>{t("trigger_custom_label")}</Text>
      <TextInput
        value={value}
        onChangeText={onChange}
        placeholder={t("trigger_custom_placeholder")}
        placeholderTextColor="#9AA0A6"
        style={styles.customInput}
        maxLength={80}
      />
    </View>
  );
}

const styles = StyleSheet.create({
  wrap: { marginBottom: 8 },
  sectionTitle: { fontSize: 16, fontWeight: "800", color: "#111", marginBottom: 4 },
  sectionHint: { fontSize: 12, color: "#6B7280", marginBottom: 12, lineHeight: 18 },
  cardGrid: {
    flexDirection: "row",
    flexWrap: "wrap",
    gap: 8,
    marginBottom: 14,
  },
  triggerCard: {
    minWidth: "30%",
    flexGrow: 1,
    paddingVertical: 12,
    paddingHorizontal: 10,
    borderRadius: 10,
    borderWidth: 2,
    borderColor: "#E5E7EB",
    backgroundColor: "#FAFAFA",
    alignItems: "center",
  },
  triggerCardOn: {
    backgroundColor: "#F0FDF4",
    borderWidth: 2.5,
  },
  triggerLabel: { fontSize: 14, fontWeight: "800", textAlign: "center" },
  triggerCount: { fontSize: 10, color: "#9CA3AF", marginTop: 4, fontWeight: "700" },
  customLabel: { fontSize: 12, fontWeight: "700", color: "#374151", marginBottom: 6 },
  customInput: {
    borderWidth: 1,
    borderColor: "#E5E7EB",
    borderRadius: 10,
    paddingHorizontal: 12,
    paddingVertical: 10,
    fontSize: 14,
    backgroundColor: "#fff",
    marginBottom: 4,
  },
});
